import styled from 'styled-components'

const Container = styled.section`
    padding-top: 10vw;;
    text-align: center;
    .code{
        font-size: 100px;
        font-weight: 500;
    }

    .title{
        font-size: 70px;
    }
`

export default function Index() {
    return (
        <Container>
            <div className="box">
                <div className="code">404</div> <br/>
                <div className="title">Page Not Found</div>
            </div>
        </Container>
    )
}
